import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityOrderNewFlowConfirmModalTemplate({ facilityOrderNewFlowConfirmModalStore, t }) {
    const {
        confirm,
        message,
        modalParams,
        isLoading,
        cancelLabel,
        confirmLabel,
    } = facilityOrderNewFlowConfirmModalStore;

    return (
        <section>
            <KeyDownListener onConfirm={() => confirm()}/>
            <div className="modal__body type--center">
                <i className="status--sqare is-big alert-circle u-mar--bottom--med u-radius--full u-cursor--default" />
                <h3 className='modal__header__title u-mar--bottom--med'>{message}</h3>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t(cancelLabel)}
                    disabled={isLoading}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={t(confirmLabel)}
                    disabled={isLoading}
                    onClick={async () => await confirm()}
                    rotate icon={
                        isLoading
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

FacilityOrderNewFlowConfirmModalTemplate.propTypes = {
    facilityOrderNewFlowConfirmModalStore: PropTypes.object,
    t: PropTypes.func
};

const KeyDownListener = ({ onConfirm }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                onConfirm();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
}
KeyDownListener.propTypes = {
};

export default defaultTemplate(FacilityOrderNewFlowConfirmModalTemplate);
